import { Outlet } from 'react-router-dom';

import { usePeopleModuleNavigation } from '../hooks/usePeopleModuleNavigation';

export function PeopleLayout() {
    usePeopleModuleNavigation();

    return (
        <div className="min-w-0 space-y-6">
            <Outlet />
        </div>
    );
}
